import { InjectionToken } from "@angular/core";
import { ExerciseFlowAdapter } from "../interfaces/exercise-flow-adapter";

export const EXERCISE_FLOW_ADAPTER_TOKEN = new InjectionToken<ExerciseFlowAdapter>('EXERCISE_FLOW_ADAPTER_TOKEN');